import { FalUrlBuilderStrategy } from './fal-url-builder-strategy';
import { FalUrlBuilderParams, UrlBuilderParams } from '../url-builder-params';

export class LocationAndTermUrlBuilderStrategy extends FalUrlBuilderStrategy {
  createUrlSegments(urlBuilderParams: FalUrlBuilderParams): void {
    this.addSegments('', urlBuilderParams.isService ? 'k' : 'r');
    this.addCityAndStateSegment(urlBuilderParams.selectedGeolocation);
    this.addSegments(urlBuilderParams?.searchTerm ? urlBuilderParams?.searchTerm : '');
  }

  shouldBuild(urlBuilderParams: UrlBuilderParams): boolean {
    return !!urlBuilderParams.searchTerm && this.hasGeolocationData(urlBuilderParams);
  }
}
